import keyBy from 'lodash/keyBy';
import values from 'lodash/values';

interface RemoveAreaPoint {
    pointLocalId: string;
    area: Area;
}

export default function removeAreaPoint({
    pointLocalId,
    area,
}: RemoveAreaPoint): SimpleArea | undefined {
    if (!area.isGeometryLoaded || !area.isGeometryEditable) return undefined;

    const updatedArea = removePointFromArea(area, pointLocalId);

    return updatedArea;
}

export function removePointFromArea(area: SimpleArea, pointLocalId: string) {
    if (!area.points[pointLocalId]) return area;
    const newPoints = values(area.points)
        .filter((otherPoint: AreaPoint) => otherPoint.properties.localId !== pointLocalId)
        .sort((a, b) => a.properties.order - b.properties.order)
        .map((otherPoint: AreaPoint, order: number) => ({
            ...otherPoint,
            properties: {
                ...otherPoint.properties,
                order,
            },
        }));

    return {
        ...area,
        points: keyBy(newPoints, 'properties.localId'),
    };
}
